const VERSION: string = '0.1.7-prod.7'
export default VERSION;
